module.exports = __webpack_public_path__ + "img/tarjeta_ofertas_salud_se_vital.0d3f6955.jpg";